export default "__VITE_ASSET__f8a5414f__"